// extracted by mini-css-extract-plugin
export var body = "_lg-0";
export var sectionHeader = "_lg-4";
export var shortcutColumns = "_lg-2";
export var shortcutList = "_lg-1";
export var shortcutSection = "_lg-3";